import { render } from "./Legals.vue?vue&type=template&id=2fa69f4d"
import script from "./Legals.vue?vue&type=script&lang=js"
export * from "./Legals.vue?vue&type=script&lang=js"

import "./Legals.vue?vue&type=style&index=0&id=2fa69f4d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__